import * as contentful from "contentful";
import _set from "lodash/set.js";
const shouldUsePreview = ["development", "preview"].includes(process.env.REACT_APP_ENV || "");
const client = ({ space, accessToken }) => contentful.createClient({
  space,
  accessToken,
  host: shouldUsePreview ? "preview.contentful.com" : void 0
});
const toTranslationObject = (result) => {
  return result.items.reduce((acc, item) => {
    return _set({ ...acc }, item.fields.key, item.fields.translation);
  }, {});
};
const toLegalDocObject = (result) => {
  return result.items.reduce((acc, item) => {
    return _set({ ...acc }, item.fields.topic, {
      ...acc[item.fields.topic],
      [item.fields.clinicReferenceId || "all"]: result.includes.Asset.find(
        (asset) => {
          var _a, _b, _c, _d;
          return ((_a = asset == null ? void 0 : asset.sys) == null ? void 0 : _a.id) === ((_d = (_c = (_b = item == null ? void 0 : item.fields) == null ? void 0 : _b.doc) == null ? void 0 : _c.sys) == null ? void 0 : _d.id);
        }
      )
    });
  }, {});
};
const getTranslations = async ({
  applicationSlug,
  clientConfig
}) => {
  const defaultQuery = {
    content_type: "translation",
    "sys.contentType.sys.id": "translation",
    "fields.application.fields.slug": applicationSlug,
    "fields.application.sys.contentType.sys.id": "application",
    limit: 1e3
  };
  const [de, en] = await Promise.all([
    client(clientConfig).getEntries({ ...defaultQuery, locale: "de-DE" }).then(toTranslationObject),
    client(clientConfig).getEntries({ ...defaultQuery, locale: "en-US" }).then(toTranslationObject)
  ]);
  return { de, en };
};
const getLegalDocuments = async ({
  clientConfig
}) => {
  const defaultQuery = { "sys.contentType.sys.id": "legalDoc", limit: 1e3 };
  const [de, en] = await Promise.all([
    client(clientConfig).getEntries({ ...defaultQuery, locale: "de-DE" }).then(toLegalDocObject),
    client(clientConfig).getEntries({ ...defaultQuery, locale: "en-US" }).then(toLegalDocObject)
  ]);
  return { de, en };
};
export {
  getLegalDocuments,
  getTranslations
};
